<template>

<div class="app-container">
      <el-container class="app-demo">
           <el-header>
            <el-menu
            
              class="el-menu"
              mode="horizontal"
              :ellipsis="false"
              @select="handleSelect"
            >

     <el-menu-item  index="home">Obsidian markmind 用户手册</el-menu-item>

      <div class="flex-grow" />
      <el-menu-item index="home/price">价格</el-menu-item>
      <el-menu-item index="home/website">网站</el-menu-item>
      <el-menu-item index="home/github">github</el-menu-item>
  </el-menu>

 </el-header>
           <el-container>
            <el-aside width="360px">
                 <el-menu
       
     
        class="el-menu-vertical-demo"
         :default-active="activeIndex"
        @select="handleSelect"
       
        
      >
        <el-sub-menu index="1">
          <template #title>
          <el-icon><Document /></el-icon>
            <span>思维导图</span>
          </template>
          <el-menu-item-group title="Basic 模式">
            <el-menu-item index="basic">创建基本的思维导图</el-menu-item>
            <el-menu-item index="basic/outline">打开为大纲模式</el-menu-item>
            <el-menu-item index="basic/table">打开为表格模式</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="Rich 模式">
            <el-menu-item index="rich">创建 rich 模式的思维导图</el-menu-item>
            <el-menu-item index="rich/markdown">获取思维导图的 markdown</el-menu-item>
            <el-menu-item index="rich/copy">复制节点</el-menu-item>
            <el-menu-item index="rich/embed">在 md 文件中嵌入思维导图</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="Shortcut">
            <el-menu-item index="rich/shortcut">快捷键</el-menu-item>
            <el-menu-item index="rich/common">快捷操作</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>

        <el-sub-menu index="2">
           <template #title>
            <el-icon><Sunny /></el-icon>
            <span>PDF 标注</span>
          </template>
          
            <el-menu-item index="pdfAnnotator">设置与功能</el-menu-item>
            <el-menu-item index="pdf/highlight">从 pdf 中提取标注</el-menu-item>
            <el-menu-item index="pdf/commitHighlight">导出标注后的 pdf</el-menu-item>
            <el-menu-item index="pdf/relate">关联节点和标注</el-menu-item>
          
        </el-sub-menu>
        <!-- <el-menu-item index="3" disabled>
          <el-icon><document /></el-icon>
          <span>Navigator Three</span>
        </el-menu-item>
        <el-menu-item index="4">
          <el-icon><setting /></el-icon>
          <span>Navigator Four</span>
        </el-menu-item> -->
      </el-menu>



            </el-aside>
              <el-container class="markdown-body">
                <router-view></router-view>
              </el-container>
          </el-container>
        </el-container>
</div>

  <Index />
</template>

<script  setup>

import { ref } from 'vue'
import {  useRouter } from 'vue-router'


const router = useRouter()

const activeIndex = ref('1');
const handleSelect = (key) => {
  if(key=='home'){
     router.push('/');
  }
  if(key=='home/github'){
     window.open('https://github.com/MarkMindCkm/obsidian-markmind')
  }

  if(key=='home/website'){
     window.open('https://www.markmind.net/cn')
  }

  if(key=='home/price'){
     router.push(key);
  }
 
  if(key.startsWith('basic')||key.startsWith('rich')||key.startsWith('pdf')){
      router.push(key);
  }
  
}




</script>

<style>

html,body{
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  color: #2c3e50;
}

.flex-grow {
  flex-grow: 1;
}

.el-menu.el-menu--horizontal{
  display: flex;
}

.markdown-body i{
   color: #196ff1;
   font-size: 0.8em;
}

.el-menu {
  border-right: 0!important;
}
.el-aside {
   border-right: solid 1px var(--el-menu-border-color);;
}
.app-container,.app-demo{
  height: 100%;
}

</style>
